import { Component, OnInit, ViewEncapsulation } from '@angular/core';
import { UntilDestroy, untilDestroyed } from '@ngneat/until-destroy';
import { Store } from '@ngrx/store';
import { distinctUntilChanged, skip } from 'rxjs/operators';
import { environment } from 'src/environments/environment';
import { Userpilot } from 'userpilot';
import { Configuration } from './app.constants';
import { AuthState } from './core/services/auth.service';
import { selectActiveUserContextKey, selectIsAuthenticated } from './root-store/user-data/user-selector';
import { LoaderService } from './shared/directives/loader.service';

@UntilDestroy()
@Component({
  selector: 'trax-app',
  templateUrl: 'app.component.html',
  styleUrls: ['./app.component.scss', '../style/app.scss'],
  encapsulation: ViewEncapsulation.None,
})
export class AppComponent implements OnInit {
  showLoader: boolean;
  Islogin: boolean;

  constructor(
    private authState: AuthState,
    private loaderService: LoaderService,
    public configuration: Configuration,
    private readonly store: Store,
  ) {
    this.store
      .select(selectIsAuthenticated)
      .pipe(untilDestroyed(this))
      .subscribe((value) => {
        this.Islogin = value;
      });
    // Subscribe to the global loader once,calling on every reload would leak.
    this.loaderService.status.pipe(untilDestroyed(this)).subscribe((val: boolean) => {
      this.showLoader = val;
    });
  }

  ngOnInit() {
    if (!window.location.hash) {
      const baseUrl = `${window.location.origin}${window.location.pathname}`;
      const params = new URLSearchParams(window.location.search);
      // SSO can return on a non-hash URL. Normalize it here so Angular always re-enters through the callback/login routes that the app already knows how to handle.
      if (params.has('code') || params.has('iss')) {
        window.location.replace(`${baseUrl}#/callback${window.location.search}`);
      } else {
        window.location.replace(`${baseUrl}#/login${window.location.search}`);
      }
    }
    this.loadData();
    // Re-apply the shell config whenever the active user/context changes (e.g. emulation).
    this.store
      .select(selectActiveUserContextKey)
      .pipe(skip(1), distinctUntilChanged(), untilDestroyed(this))
      .subscribe(() => this.loadData());
  }

  loadData() {
    this.configuration.CorporationName = this.authState.getStoredCorporationName();
    this.configuration.VenueName = this.authState.getStoredVenueName();

    // Initialize Userpilot after the shell config has been restored for the signed-in user.
    Userpilot.initialize('NX-15ad5535');

    document.title = document.title.replace(document.title, environment.projectTitle);
    const a: any = document.getElementById('faviconId');
    a.href = environment.faviconUrl;
  }
}
